
import { FSXABaseComponent } from 'fsxa-pattern-library'
import { Component } from 'nuxt-property-decorator'
import PageHeader from './PageHeader.vue'
import PageOverlays from './PageOverlays.vue'
import PageFooter from './PageFooter.vue'
import PageContent from './PageContent.vue'

@Component({
  name: 'Page',
  components: {
    PageHeader,
    PageContent,
    PageOverlays,
    PageFooter,
  },
})
export default class Page extends FSXABaseComponent {
  private headerHeight = 169 // default on desktop

  private async mounted () {
    this.setHeaderHeight()
    window.addEventListener('resize', this.setHeaderHeight)
  }

  private setHeaderHeight () : void {
    const newHeight = document.querySelector('#header')?.getBoundingClientRect().height
    if (newHeight === undefined) return
    this.headerHeight = newHeight
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.setHeaderHeight)
  }
}
